module.exports = __webpack_public_path__ + "media/images/avatar/16-770da16701fa41e3c4286ae159ad6b74.svg";